import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { CountedLampCatalogue } from '@app/shared/models/lamp-catalogue/lamp-catalogue';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LampCatalogueService extends ApiService {
  private baseUri = 'socrates/streetlights/api/references/lampcatalogue';
  constructor(public http: HttpClient) {
    super(http);
  }

  public getLampCatalogue(searchText?: string): Observable<CountedLampCatalogue> {
    let q = '?$filter=isActive eq true';

    if (!!searchText) {
      q += ` and contains(name, '${searchText}')`;
    }

    q += '&$orderby=name&$count=true';

    return this.http.get<CountedLampCatalogue>(this.endpoint(this.baseUri, q));
  }

  public createLampCatalogue(lamp: FormData): Observable<Object> {
    return this.http.post<Object>(this.endpoint(`api`, `lampcatalogue`), lamp);
  }

  public updateLampCatalogue(lamp: FormData, guid: string): Observable<Object> {
    return this.http.put<Object>(this.endpoint(`api`, `lampcatalogue`, guid), lamp);
  }

  public deleteLampCatalogue(guid: string): Observable<Object> {
    return this.http.delete<Object>(this.endpoint(`api`, `lampcatalogue`, guid));
  }
}
